import { css } from '@emotion/react';

import { claudeTokens } from './claudeTokens';

export const globalStyles = css`
    html,
    body,
    #root {
        font-family: 'Pretendard Variable', Pretendard, 'Noto Sans KR', system-ui, sans-serif;
        background-color: ${claudeTokens.color.bg};
        margin: 0;
        padding: 0;
        width: 100%;
        /* 스크롤 끝 러버밴드(바운스) 시 sticky 헤더가 딸려 움직이지 않도록 바운스 제거 */
        overscroll-behavior-y: none;
    }

    /*
     * 가로 넘침 자르기는 body·#root 에만 건다(hidden 은 스크롤 상자를 만들어 sticky 를 무력화하므로 clip).
     * html 에는 걸지 않는다 — html 의 overflow 가 visible 이어야 body 의 overflow 가 화면(뷰포트)으로 넘어간다.
     * html 이 clip 이면 MUI Modal·Dialog 의 기본 스크롤 잠금(body overflow:hidden)이 body 자신을 잘림 상자로 만들어,
     * 페이지를 내린 채 창을 열면 sticky 머리줄·탭 줄이 내린 만큼 화면 위로 사라졌다(2026-10-07 로그인 안내 창, 머리줄 top 0→-243).
     * 지금은 body 의 clip 이 화면으로 넘어가(화면 기준 가로 hidden) 가로 스크롤은 그대로 막히고, #root 의 clip 이 앱 영역을 자른다.
     */
    body,
    #root {
        overflow-x: clip;
    }

    body {
        color: ${claudeTokens.color.text1};
    }

    a {
        text-decoration: none;
        color: inherit;
    }
    ::-webkit-scrollbar {
        width: 5px;
    }
    
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
      
    ::-webkit-scrollbar-thumb {
        background: #888; 
        border-radius: 5px;
    }
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`;
